import { useRouter } from "@tanstack/react-router";
import { AnchorHTMLAttributes, forwardRef, MouseEvent } from "react";

export interface LinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  href: string;
  replace?: boolean;
  scroll?: boolean;
  prefetch?: boolean | null;
}

const isPlainClick = (event: MouseEvent<HTMLAnchorElement>): boolean =>
  event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

// 앱 안 주소만 라우터로 옮긴다 — 다른 사이트·mailto·tel·# 은 브라우저 기본 동작.
export const isInAppHref = (href: string): boolean => href.startsWith("/") && !href.startsWith("//");

// next/link 대체(D3) — <a href> 를 그대로 그려 새 탭·우클릭·이탈 확인(leave-guard)이 같고, 보통 클릭만 라우터로 옮긴다 · 속성 순서도 next/link 처럼 나머지 → href.
const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ href, replace, scroll, prefetch: _prefetch, onClick, ...rest }, ref) => {
  const router = useRouter();
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (event.defaultPrevented || !isPlainClick(event)) return;
    if ((rest.target && rest.target !== "_self") || rest.download !== undefined || !isInAppHref(href)) return;
    event.preventDefault();
    void router.navigate({ href, replace, resetScroll: scroll !== false });
  };
  return <a {...rest} ref={ref} onClick={handleClick} href={href} />;
});

Link.displayName = "Link";

export default Link;
